import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Typography, Alert, Button } from '@mui/material';
import { ROUTES } from '../../utils/constants';

const MagicLinkPage: React.FC = () => {
  return (
    <Box>
      <Typography variant="h5" fontWeight={600} sx={{ mb: 3 }}>
        Sign In
      </Typography>
      <Alert severity="info" sx={{ mb: 3 }}>
        Magic links are no longer supported. Please sign in using your email code instead.
      </Alert>
      <Button
        component={RouterLink}
        to={ROUTES.LOGIN}
        fullWidth
        variant="contained"
        size="large"
      >
        Go to Sign In
      </Button>
    </Box>
  );
};

export default MagicLinkPage;
